import React, { Component } from 'react';
import DocumentMeta from 'react-document-meta';
import '../../../src/styles/Home.css';
import Search from '../Home/Search.jsx';
import queryString from 'query-string';
import { LoginLeadingLawPublication, LoginPublicationShowcase, LoginAuthorSpotlight, LoginHomeLatestUpdates } from './index';
import { appService } from '../../_services';
import { userService } from '../../_services';
import Spinner from '../Spinner';
import ReactGA from 'react-ga';
let user = '', useragent = navigator.userAgent;

export class LoginHome extends Component {
    displayName = LoginHome.name
    constructor(props) {
        super(props);
        this.state = {
            users: "",
            items: [],
            Subscriptions: [],
            Journals: [],
            Manuals: [],
            Encyclopedias: [],
            LatestUpdates: [],
            LatestPubList: [],
            AuthorLst: [],
            mktCampaign: [],
            loading: true,
            loginlogout: false,
            mfaMessage: ""
        };
    }

    componentDidMount() {
        this.handleMfaReturn();

        //  });

        //let url = this.props.location.search;
        //let params = queryString.parse(url);
        //var self = this;
        //var urlstring = (typeof params.code === "undefined" ? "/AppData/GetUser":"/User/ExchangeToken?code="+params.code);
        // userService.login(urlstring)
        //     .then(function (data) {                  
        //         self.setState({ users: data });
        //         appService.getAll('Home/GetHomePageDataWithLogin')
        //             .then(function (homedata) {
        //                 //console.log(homedata);
        //                 self.setState({ loading: false });
        //                 self.setState({ items: homedata });
        //                 self.setState({ Subscriptions: homedata.listSubscribed });
        //                 self.setState({ Journals: homedata.listJournal });
        //                 self.setState({ Manuals: homedata.listManual });
        //                 self.setState({ Encyclopedias: homedata.listEncyclopedia });
        //                 self.setState({ LatestUpdates: homedata.listLatestUpdates });
        //                 self.setState({ AuthorLst: homedata.listAuthor });
        //                 self.setState({ mktCampaign: homedata.mktCampaign });
        //             });

        //     });
        //if (localStorage.getItem('user') !== null) {
        //    appService.getAll('Home/GetHomePageDataWithLogin')
        //        .then(function (homedata) {
        //            console.log(homedata);
        //            self.setState({ loading: false });
        //            self.setState({ items: homedata });
        //            self.setState({ Subscriptions: homedata.listSubscribed });
        //            self.setState({ Journals: homedata.listJournal });
        //            self.setState({ Manuals: homedata.listManual });
        //            self.setState({ Encyclopedias: homedata.listEncyclopedia });
        //            self.setState({ LatestUpdates: homedata.listLatestUpdates });
        //            self.setState({ AuthorLst: homedata.listAuthor });
        //            self.setState({ mktCampaign: homedata.mktCampaign });
        //        });
        //}

        if (localStorage.getItem('user') !== null) {
            window['NTPT_PGEXTRA'] = '&user_id=' + localStorage.getItem('salesForceID') + ' &User=' + localStorage.getItem('user') + '&platform=klo &useragent=' + useragent;
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }
        else {
            window['NTPT_PGEXTRA'] = 'platform=klo';
            const script = document.createElement("script");
            script.src = "/siqpagetag.js";
            script.async = true;
            document.body.appendChild(script);
        }

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Home");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }

    handleMfaReturn() {
        let url = this.props.location.search;
        let params = queryString.parse(url);
        const mfaStatus = ((params.mfa || '') + '').toLowerCase();

        if (!mfaStatus) {
            this.loadLoginHomeData();
            return;
        }

        if (mfaStatus === 'success') {
            this.handleMfaSuccess();
            return;
        }

        this.setState({ mfaMessage: this.getMfaMessageForStatus(mfaStatus) });
        this.loadLoginHomeData();
        this.clearMfaQueryParameter();
    }

    handleMfaSuccess() {
        var self = this;

        userService.getMfaUser()
            .then(function (mfaUser) {
                if (mfaUser && mfaUser.username) {
                    self.persistMfaUser(mfaUser);
                    self.setState({ mfaMessage: "" });
                } else {
                    self.setState({ mfaMessage: "We couldn't complete your Microsoft sign-in. Please try again." });
                }
            })
            .catch(function () {
                self.setState({ mfaMessage: "A sign-in error occurred. Please try again." });
            })
            .then(function () {
                self.loadLoginHomeData();
                self.clearMfaQueryParameter();
            });
    }

    loadLoginHomeData() {
        var self = this;
        let data = localStorage.getItem('user');
        self.setState({ users: data });

        var parameters = {
            user: data ? JSON.parse(data) : null,
        }
        appService.getByIssueId('Home/GetHomePageDataWithLogin', parameters)
            .then(function (homedata) {
                //console.log(homedata);
                if (homedata.isErrorExist == true) {
                    //window.location = "/Maintenance";;
                }

                self.setState({ loading: false });
                self.setState({ items: homedata });
                self.setState({ Subscriptions: homedata.listSubscribed });
                self.setState({ Journals: homedata.listJournal });
                self.setState({ Manuals: homedata.listManual });
                self.setState({ Encyclopedias: homedata.listEncyclopedia });
                self.setState({ LatestUpdates: homedata.listLatestUpdates });
                self.setState({ AuthorLst: homedata.listAuthor });
                self.setState({ mktCampaign: homedata.mktCampaign });
            })
            .catch(function () {
                self.setState({ loading: false });
            });
    }

    getMfaMessageForStatus(status) {
        if (status === 'nomatch') {
            return "Your Microsoft account isn't linked to a Kluwer Law subscription.";
        }

        if (status === 'limit') {
            return "Concurrent-user limit reached.";
        }

        return "A sign-in error occurred. Please try again.";
    }

    persistMfaUser(mfaUser) {
        localStorage.setItem('userId', mfaUser.id || mfaUser.userId || '');
        localStorage.setItem('company', mfaUser.company || '');
        localStorage.setItem('firstName', mfaUser.firstName || '');
        localStorage.setItem('lastName', mfaUser.lastName || '');
        localStorage.setItem('user', JSON.stringify(mfaUser.username));
        localStorage.setItem('usersubscription', mfaUser.userSubscription || '');
        localStorage.setItem('salesForceID', mfaUser.customerID || mfaUser.customerId || '');
        localStorage.setItem('version', '1.0');
        localStorage.setItem('setupTime', new Date().getTime());
    }

    clearMfaQueryParameter() {
        const currentSearch = this.props.location && this.props.location.search ? this.props.location.search.toLowerCase() : '';
        if (this.props.history && currentSearch.indexOf('mfa=') >= 0) {
            this.props.history.replace(this.props.location.pathname);
        }
    }


    render() {
        const meta = {
            title: "Kluwer Law Online - Home",
            canonical: window.location.href,
        }
        if (this.state.loading) {
            return <Spinner />
        }
        else {
            return (
                <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        {this.state.mfaMessage ?
                            <div className="alert alert-warning" role="alert">{this.state.mfaMessage}</div>
                            : null
                        }

                        <div className="row" id="flex-container">

                            <div className="col-lg-8">
                                <div className="col-lg-12 BgWhite">
                                    <LoginLeadingLawPublication
                                        subscribedList={this.state.Subscriptions}
                                    />
                                </div>
                                    <div className="col-lg-12 margintop BgWhite">
                                    <LoginPublicationShowcase
                                        journalList={this.state.Journals}
                                        encyclopediaList={this.state.Encyclopedias}
                                        manualList={this.state.Manuals}
                                    />
                                </div>
                                <div className="col-lg-12 margintop BgWhite">
                                    <h3 className="LawHeader">Author Spotlight</h3>
                                    <LoginAuthorSpotlight AuthorList={this.state.AuthorLst} />
                                </div>
                            </div>
                            <div className="col-lg-4 BgWhite">
                                <h3 className="LawHeader">Latest Updates</h3>
                                <br></br>
                                <LoginHomeLatestUpdates LatestUpdatesList={this.state.LatestUpdates} />
                            </div>

                        </div>


                        <div className="Grey">
                        </div>

                    </div>

                </div>
                    </DocumentMeta>

            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/LoginHome/LoginHome.jsx